import React from 'react';
import { useLoggedUser } from 'state/user';
import { useQuery } from '@apollo/client';
import { fetchLoggedUserQuery } from 'graphql/user/queries/fetch-logged-user';

export default function useFetchLoggedUser() {
  const [_, setLoggedUser] = useLoggedUser();

  const isLoginOrRegisterPage = ['login', 'register', 'share'].some((path) =>
    window.location.pathname.includes(path),
  );

  const { data, loading, error } = useQuery(fetchLoggedUserQuery, {
    skip: isLoginOrRegisterPage,
    fetchPolicy: 'network-only',
  });

  const user = data?.fetchLoggedUser?.data;

  const isError = error || data?.fetchLoggedUser?.error;

  React.useEffect(() => {
    if (isError) {
      if (
        window.location.href.includes('immoox') ||
        window.location.href.includes('immo-ox')
      ) {
        window.location.replace('/immo-ox/login');
        return;
      }
      window.location.replace('/login');
    }
  }, [isError]);

  React.useEffect(() => {
    setLoggedUser(user ?? null);
  }, [user, setLoggedUser]);

  return { user, loading };
}
